import React from "react";
import CustomTableAccountPlan from "./CustomTableAccountPlan";
import { useMainStore } from "@/stores";
import { useFetchAccountActionPlan } from "@/features/accounts/hooks/useAccounts";
import { useParams } from "react-router-dom";
import Loader from "@/shared/components/ui/Loaders/Loader";

const ActionPlan = () => {
  const { user } = useMainStore();
  const { companyDomain } = useParams();
  const organizationId = user?.organization_id || user?.organizationId || "";
  const { data: accountActionPlan, isLoading: isLoadingAccountActionPlan } =
    useFetchAccountActionPlan({
      userId: user?.id,
      organizationId,
      companyName: companyDomain,
      enabled: !!user?.id && !!organizationId && !!companyDomain,
    });

  // Transform API data
  const actions = accountActionPlan?.actions || [];
  const transformedActions = actions.map((action) => ({
    id: action.id,
    action: action.action || "",
    description: action.description || "",
    owner: action.owner || "",
    dueDate: action.due_date || "",
    status: action.status || "",
  }));
  const organizationUsers = accountActionPlan?.organization_users || [];

  if (isLoadingAccountActionPlan) {
    return (
      <div className="flex h-full min-h-0 items-center justify-center">
        <Loader text="Loading action plan..." />
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-4">
      <h1 className="shrink-0 text-[0.775rem] font-normal leading-5 font-inter text-gray-800 dark:text-gray-200">
        <span className="font-semibold text-[0.783rem] text-gray-900 dark:text-gray-100">
          Account Goal:{" "}
        </span>
        <span className="font-normal text-gray-700 dark:text-gray-300 text-[0.783rem]">
          Increase adoption of AI-powered sales automation
        </span>
      </h1>
      <div className="min-h-0 flex-1">
        <CustomTableAccountPlan
          initialActions={transformedActions}
          users={organizationUsers}
        />
      </div>
    </div>
  );
};

export default ActionPlan;
